module.exports = __webpack_public_path__ + "static/media/vrs1.81b07979.png";